/**
 * Sign Up — court-exhibit auth shell (AuthLayout + AuthBrandPanel) wrapping the
 * Clerk <SignUp> widget. Branding panel + form styling live in components/auth;
 * this page only wires the Clerk widget + the signed-in redirect guard.
 */

import { SignUp, useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import { authClerkAppearance } from '../components/auth/clerkAppearance';

export default function SignUpPage() {
  const { isSignedIn, isLoaded } = useUser();

  if (isLoaded && isSignedIn) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Set up your workspace in a few minutes."
      altPrompt="Already have an account?"
      altLinkText="Sign in"
      altLinkTo="/sign-in"
      securedNote="Secured by Clerk · encrypted in transit"
    >
      <SignUp
        routing="hash"
        signInUrl="/sign-in"
        fallbackRedirectUrl="/"
        appearance={authClerkAppearance}
      />
    </AuthLayout>
  );
}
